import { getRelativeFontSize, mediumFont, boldFont, PrimaryTextColor,regularFont } from "../../utils/styles";


const AttendanceStyles = {
  attendanceWrapper: {
    padding: "20px 20px",
  },
  rowtext: {
    ...mediumFont,
    color: PrimaryTextColor,
    fontSize: getRelativeFontSize(-3),
    display: "flex",
    alignItems: "center",
  },
  dipt: {
    color: "#6D6E82",
    ...boldFont,
  },

  fullName: {
    ...regularFont,
    fontcolor: "#0C0E2E",
    fontSize: getRelativeFontSize(0),
    textTransform: "capitalize",
  },
  indicWrapper: {
    display: "flex",
    gap: "25px",
  },
  indicBox: {
    display: "flex",
    gap: "5px",
  },
  presentBox: {
    background: "#18CB8A",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },
  LeaveBox: {
    background: "#E92B2B",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },
  HolidayBox: {
    background: "#F4BE5E",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },
  WeeklyOffBox: {
    background: "#8B91EF",
    width: "20px",
    height: "20px",
    borderRadius: "5px",
  },

  filterButton: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    justifyContent: "center",
    height: "46px",
  },

  filterName: {
    ...mediumFont,
    fontSize: getRelativeFontSize(2),
    color: "#11142D",
    "& img": {
      marginLeft: "10px",
    },
  },

  teamName: {
    fontSize: "14px", 
    fontWeight: "700", 
    textTransform:"capitalize",
  },
  activeBtn: {
    "& button": {
      height: "23px",
      width: "45px",
      fontSize: getRelativeFontSize(-3),
      ...mediumFont,
    },
  },

  verticalDotButton: {
    "& button": {
      "&:hover": {
        background: "none",
      },
    },
  },

  innerPopOver: {
    padding: "5px",
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "column",
    justifyContent: "start",
    alignItems: "start",
    "& button": {
      width: "fit-content",
      "&:hover": {
        background: "none",
      },
    },
  },
  tableGridPart:{
    "& .MuiDataGrid-withBorderColor":{
      border: "none",
    },
    "& .MuiDataGrid-main": {
      borderTop: "1px solid #EEEFF2",
    },
    "& .MuiDataGrid-columnHeaders":{
      borderBottom: "1px solid #EEEFF2",
      fontSize:"14px",
      ...boldFont,
    },
  },
};

export default AttendanceStyles;
